module.exports = {"340104001":"三里庵街道","340104002":"稻香村街道","340104003":"琥珀街道","340104004":"南七街道","340104005":"西园街道","340104006":"五里墩街道","340104007":"荷叶地街道","340104008":"笔架山街道","340104100":"井岗镇","340104101":"南岗镇","340104102":"小庙镇","340104400":"蜀山新产业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340104.json
// module id = 1037
// module chunks = 0